<template>
    <div>
        <modal class="verified-email-has-sent" :class="{'no-close': noClose}" :display="modalStatus.verifiedEmailHasSent">
            <alarm-msg-white type="SUCCESS" :msg="alarm.success.msg" :count="alarm.success.count" :showAlarm="alarm.success.status" @timeOut="alarm.success.status=false"></alarm-msg-white>
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <div class="verified-email-has-sent-wrap">
                <img src="@/assets/img/pages/registerFlow/email.svg" alt="">
                <h1>註冊驗證信件已送出</h1>
                <div class="description">
                    您將收到一封來自飛豬管家的註冊驗證信，<br>
                    麻煩至信箱查收以完成註冊流程。<br>
                    如果沒有收到認證信，可以 <span class="resend" @click="resendEmail()">按此重發</span>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import { apiBizResendVerified } from "@/apis/api.js"; 
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            error: {
                resend: {
                    account: null
                }
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 2000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 2000
                }
            },
            
        }
    },
    props: {
        noClose: Boolean,
        email: String
    },
    methods: {
        resendEmail: function () {
            let email = this.email
            let data = {email}

            apiBizResendVerified(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.alarm.success.msg = '驗證信已重發，麻煩至信箱查收以完成註冊流程'
                    this.alarm.success.status = true
                }else{
                    this.alarm.error.msg = res.data.errorMsg
                    this.alarm.error.status = true
                }
            })
            .catch(err => {
                console.log(err)
                this.alarm.error.msg = '系統發生未預期錯誤，請再試一次'
                this.alarm.error.status = true
            })
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        alarmMsgWhite
    }
}
</script>
<style lang="scss"  >
    #modal.verified-email-has-sent{
        .modal-content{
            width: 474px;
            height: 422px;
            padding: 0 !important;
            .detail{
                .verified-email-has-sent-wrap{
                    position: relative;
                    border-radius: 6px;
                    background: #FFF;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    img{
                        margin-top: 84px;
                        margin-bottom: 20px;
                    }
                    h1{
                        font-size: 24px;
                        margin-bottom: 20px;
                        font-weight: 500;
                    }
                    .description{
                        text-align: center;
                        line-height: 1.5;
                        .resend{
                            color: #ff9275;
                            text-decoration: underline;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
    @media screen and (max-width: 560px) {
        #modal.verified-email-has-sent{
            .modal-content{
                width: 325px;
                height: 334px;
                .detail{
                    .verified-email-has-sent-wrap{
                        img{
                            margin-top: 40px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/widges/modals/verifiedEmailHasSent.vue